import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import React, { useContext, forwardRef, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dropdown from '../Dropdown';
import DropdownMenuContext from './DropdownMenuContext';
import { useAccessibleKeyboardNavigationHandler } from '../hooks';
const Root = styled.div.withConfig({
  displayName: "DropdownMenuList__Root",
  componentId: "sc-1o4jkny-0"
})(["padding:var(--size-spacing-02) 0;display:flex;flex-direction:column;"]);
const DropdownMenuList = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const dropdownRef = useRef();
  const {
    id,
    position,
    offset,
    triggerElement,
    isOpen,
    toggle
  } = useContext(DropdownMenuContext);

  const handleClickOutside = e => isOpen && toggle(e);

  const handleKeyDown = useAccessibleKeyboardNavigationHandler(dropdownRef, toggle);
  return /*#__PURE__*/React.createElement(Dropdown, _extends({}, rest, {
    ref: ref,
    role: "menu",
    anchorId: id,
    anchorEl: triggerElement,
    open: isOpen,
    position: position,
    offset: offset,
    onClickOutside: handleClickOutside,
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/React.createElement(Root, {
    ref: dropdownRef
  }, children));
});
DropdownMenuList.displayName = 'DropdownMenu.List';
DropdownMenuList.defaultProps = {
  children: null
};
process.env.NODE_ENV !== "production" ? DropdownMenuList.propTypes = {
  /**
   * Sets the children element
   */
  children: PropTypes.node
} : void 0;
DropdownMenuList.Style = Dropdown.Style;
export default DropdownMenuList;